// ===== PRODUCT PAGE — gallery, quantity, variant, pincode (isolated) =====
document.addEventListener('DOMContentLoaded', () => {
  try {
    const wrap = document.getElementById('product-detail');
    if (!wrap) return; // not on a product page — do nothing

    // ---------- Gallery ----------
    const mainImg = document.getElementById('pd-active-img');
    document.querySelectorAll('.pd-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.pd-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });

    // ---------- Quantity stepper ----------
    const qtyInput = document.getElementById('qty-val');
    document.getElementById('qty-minus')?.addEventListener('click', () => {
      const newVal = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      qtyInput.value = newVal;
    });
    document.getElementById('qty-plus')?.addEventListener('click', () => {
      const newVal = Math.min(20, parseInt(qtyInput.value, 10) + 1);
      qtyInput.value = newVal;
    });

    // ---------- Variant selection ----------
    const variantDataEl = document.getElementById('pd-variant-data');
    const variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    const variantInput = document.getElementById('pd-variant-input');

    function formatMoney(cents) {
      // Uses the shop's active currency via Intl — matches Shopify's own formatting closely.
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    }

    function applyVariant(variant) {
      if (!variant) return;
      variantInput.value = variant.id;

      document.getElementById('pd-price').textContent = formatMoney(variant.price);

      const compareEl = document.getElementById('pd-compare');
      const saveEl = document.getElementById('pd-save');
      const hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      compareEl.style.display = hasSale ? '' : 'none';
      compareEl.textContent = hasSale ? formatMoney(variant.compare_at_price) : '';
      saveEl.style.display = hasSale ? '' : 'none';
      saveEl.textContent = hasSale ? `Save ${formatMoney(variant.compare_at_price - variant.price)}` : '';

      document.getElementById('pd-stock-dot').classList.toggle('out', !variant.available);
      document.getElementById('pd-stock-text').textContent = variant.available ? 'In Stock' : 'Out of Stock';

      const addBtn = document.getElementById('pd-add-btn');
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';

      const sizeLabel = document.getElementById('pd-selected-size');
      if (sizeLabel) sizeLabel.textContent = variant.option1;

      document.querySelectorAll('.pd-variant-btn').forEach(btn => {
        btn.classList.toggle('active', String(btn.dataset.variantId) === String(variant.id));
      });

      // Sync main image if this variant has its own photo
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        document.querySelectorAll('.pd-thumb').forEach(t => {
          t.classList.toggle('active', t.dataset.src === variant.featured_image.src);
        });
      }
    }

    document.querySelectorAll('.pd-variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const variant = variants.find(v => String(v.id) === String(btn.dataset.variantId));
        applyVariant(variant);
      });
    });

    // ---------- Pincode checker (ported literally — no external API call, matches original) ----------
    const deliveryType = wrap.dataset.deliveryType || 'pan_india';

    function isDelhiNcrPin(pin) {
      return /^(110|121|122|201)/.test(pin);
    }

    function escapeHTML(value) {
      return String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[char]));
    }

    function bindPincodeButton() {
      const btn = document.getElementById('pincode-btn');
      if (btn) btn.addEventListener('click', checkPincode);
    }

    function checkPincode() {
      const pinInput = document.getElementById('pincode-input');
      const resultEl = document.getElementById('pincode-result');
      const pin = pinInput.value.trim();

      resultEl.style.display = 'block';
      resultEl.className = 'pincode-result';

      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        resultEl.classList.add('err');
        resultEl.textContent = 'Please enter a valid Indian 6-digit PIN code.';
        return;
      }

      if (deliveryType === 'delhi_only' && !isDelhiNcrPin(pin)) {
        resultEl.classList.add('err');
        resultEl.textContent = 'This product is currently available for Delhi/NCR delivery only.';
        return;
      }

      const stateEl = document.getElementById('pincode-check-state');
      stateEl.innerHTML = `
        <div class="pincode-estimate">
          <div class="pincode-estimate-item"><span class="pincode-estimate-icon">&#8982;</span><span>${escapeHTML(pin)}</span></div>
          <div class="pincode-estimate-item"><span class="pincode-estimate-icon">&#10003;</span><span>${deliveryType === 'delhi_only' ? 'Delhi/NCR' : 'Available'}</span></div>
        </div>
        <button type="button" class="pincode-change" id="pincode-change-btn">Change pincode</button>
        <div class="pincode-result ok" style="display:block;">Delivery is available for this PIN code. Standard delivery time is 8-10 days.</div>
      `;
      document.getElementById('pincode-change-btn')?.addEventListener('click', resetPincodeForm);
    }

    // ---------- Sticky gallery offset (self-correcting: re-measures whenever header size actually changes) ----------
    function updateStickyOffset() {
      const announcementBar = document.querySelector('.announcement-bar');
      const nav = document.getElementById('nav');
      const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
      const navHeight = nav ? nav.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--sticky-header-offset', `${announcementHeight + navHeight + 16}px`);
    }
    updateStickyOffset();
    window.addEventListener('resize', updateStickyOffset);

    if (window.ResizeObserver) {
      const headerObserver = new ResizeObserver(updateStickyOffset);
      const announcementBarEl = document.querySelector('.announcement-bar');
      const navEl = document.getElementById('nav');
      if (announcementBarEl) headerObserver.observe(announcementBarEl);
      if (navEl) headerObserver.observe(navEl);
    }

    function resetPincodeForm() {
      const stateEl = document.getElementById('pincode-check-state');
      stateEl.innerHTML = `
        <div class="pincode-row">
          <input class="pincode-input" id="pincode-input" type="text" inputmode="numeric" maxlength="6" pattern="[1-9][0-9]{5}" placeholder="Enter pincode">
          <button type="button" class="pincode-btn" id="pincode-btn">Check</button>
        </div>
        <div class="pincode-result" id="pincode-result"></div>
        <div class="pincode-helper">${deliveryType === 'delhi_only' ? 'This product is currently delivered within Delhi/NCR only.' : 'This product is delivered across India.'}</div>
      `;
      bindPincodeButton();
      document.getElementById('pincode-input')?.focus();
    }

    bindPincodeButton();

    document.addEventListener('keydown', (e) => {
      const input = document.getElementById('pincode-input');
      if (input && e.key === 'Enter' && document.activeElement === input) {
        document.getElementById('pincode-btn')?.click();
      }
    });

  } catch (err) {
    console.error('Product page script failed to initialize:', err);
  }
});
